import { normalizeUPApiError, getContextualRequest } from '../../../modules/utils/index.js';
import { mapChannels } from './mapper.js';
import { promoUPChannelComparator } from './utils.js';
export async function fetchChannelsByLocation(client, params) {
    try {
        const { limit, isPromo = false } = params;
        const url = `${client.context.api.host}/channels-by-location`;
        const req = await getContextualRequest(client);
        const res = await req.post(url).send({
            user_country: params.userCountry,
            current_postal_code: params.currentPostalCode, // if undefined, we will only get the national channels
        });
        let channels = res.body;
        if (isPromo) {
            channels = channels
                .filter((channel) => channel.tags.includes('promo'))
                .sort(promoUPChannelComparator);
        }
        if (limit) {
            channels = channels.slice(0, limit);
        }
        return mapChannels(channels);
    }
    catch (error) {
        throw normalizeUPApiError(error);
    }
}
